<template>
    <footer class="section-footer">
        <button type="button" id="paymentbutton" class="btn" disabled>
            {{payButtonText}}
        </button>
    </footer>
</template>

<script src='./default-place-order-button-disabled.js'></script>
